import { render, staticRenderFns } from "./physiologyGraphicAvgStudentSprint.vue?vue&type=template&id=4b7babe8&"
import script from "./physiologyGraphicAvgStudentSprint.js?vue&type=script&lang=js&"
export * from "./physiologyGraphicAvgStudentSprint.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports